export default __webpack_public_path__ + "static/media/saurabh.f4dfc9b6.JPG";